<template>
<div class="detail-card">
  <div class="card-header">
    <div class="card-title">
      {{title}}
    </div>
    <div>
      <slot name="header"></slot>
    </div>
  </div>
  <div class="cardLine" />
  <div v-if="isShow" class="detail-content">
    <slot></slot>
  </div>
  <div v-else class="detail-empty">
    <img class="empty-img" src="../img/nodata.png" alt="">
    <div class="no-data-title">{{ noDataTitle }}</div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: true
    },
    noDataTitle: {
      type: String,
      default: '暂无数据'
    }
  },
};
</script>

<style scoped lang="less">
.detail-card {
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  align-items: center;
  border-radius: 10px;
  background-color: #FFFFFF;
}

.card-header {
  width: 100%;
  min-width: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}

.card-title {
  font-size: 16px;
}

.cardLine {
  width: 100%;
  border-top: 1px solid #ccc;
}

.detail-content {
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 20px;
}

.detail-empty {
  width: 100%;
  min-width: 0;
  height: 520px;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background: url("../img/nodata-bg.png") no-repeat center;
}

.empty-img {
  width: 220px;
  height: 156px;
}

.no-data-title {
  font-size: 16px;
  color: rgba(0,0,0,0.4);
  font-family: OPPOSans-M, sans-serif;
  margin-top: 10px;
}
</style>
